import React from 'react'
import { Text, IconArrowDown, IconArrowUp, csx } from '@vtex/admin-ui'
import type { TextProps, StyleProp } from '@vtex/admin-ui'
import { FormattedNumber } from 'react-intl'

type PercentageDifferenceOptions = {
  value: number
}

export type PercentageDifferenceProps = Omit<
  TextProps,
  keyof PercentageDifferenceOptions
> &
  PercentageDifferenceOptions & { value: number }

export const PercentageDifference = ({
  value,
  className,
  ...props
}: PercentageDifferenceProps) => {
  const positive = value >= 0
  const tone = positive ? 'positive' : 'critical'

  const iconBaseStyle: StyleProp = {
    minWidth: '0.75rem',
    minHeight: '0.75rem',
    width: '0.75rem',
    height: '0.75rem',
    marginRight: '$space-1',
  }

  return (
    <Text
      variant="action1"
      tone={tone}
      className={csx({
        alignItems: 'center',
      })}
      {...props}
    >
      {positive ? (
        <IconArrowUp className={csx({ ...iconBaseStyle })} />
      ) : (
        <IconArrowDown className={csx({ ...iconBaseStyle })} />
      )}
      <FormattedNumber style="percent" value={Math.abs(value) / 100} />
    </Text>
  )
}
